<template>
    <div class="text-center">
        <v-dialog v-model="dialog" max-width="800">
            <template v-slot:activator="{ on, attrs }">
                <v-btn color="lighten-2" dark v-bind="attrs" v-on="on">
                    新型コロナウイルス感染症対策について
                </v-btn>
            </template>

            <v-card light class="pa-5 pa-sm-10 pa-lg-15" style="background: #f2f2f2;">
                <v-card-title class="headline">
                    新型コロナウイルス感染症対策について
                </v-card-title>

                <v-card-title class="text-title-1 font-weight-bold" style="color:#333;">
                    お客様へのお願い
                </v-card-title>

                <v-card-text>
                    <p class="text-subtitle-1 font-weight-bold" style="color:#00d1d5;">以下の条件に当てはまる方はご来場をお断りしております。</p>
                    <ul>
                        <li>発熱や風邪、味覚障害の症状があるお客様</li>
                        <li>体調がすぐれないお客様</li>
                        <li>身近に新型コロナウイルス感染症の感染者もしくは感染の可能性のある方がいらっしゃるお客様</li>
                        <li>ご自身または身近に、過去14日以内に海外への渡航歴があるお客様</li>
                    </ul>
                    <p class="text-subtitle-1 mt-10 font-weight-bold" style="color:#00d1d5;">
                        ご来場の際は必ずマスクを着用いただき、咳やくしゃみをされる際は「咳エチケット」を厳守ください。マスクもしくは口元を覆う布類をお持ちでない方は、入場をお断りする場合がございます。</p>

                    <ul>
                        <li>入り口での手指消毒のご協力をお願いいたします。</li>
                        <li>入り口にて検温をさせていただきます。37.5度以上の発熱が認められた場合、入場をお断りします。</li>
                        <li>紙チケットをご購入されたお客様については、連絡の取れる代表者様ご連絡先の記入にご協力をお願いいたします。万一、感染が発生した際には、感染拡大防止のため、保健所からの要請を受けて、それを提出させていただく場合があります。
                        </li>
                        <li>混雑防止のため、入場制限をさせていただく場合がございます。スタッフの指示に従ってくださいますようお願いいたします。</li>
                        <li>飛沫感染予防のため、極力会話はお控えください。</li>
                        <li>待機列、展示室内では、ソーシャルディスタンスへのご配慮をお願いいたします。</li>
                        <li>要請にご協力いただけない場合、退出をお願いする場合がございます。</li>
                    </ul>
                    <p class="mt-3">当面の間、大変ご不便をおかけしますが、皆様に安心して展覧会をお楽しみいただくために、ご理解、ご協力のほど、何卒よろしくお願い申し上げます。</p>

                </v-card-text>

                <v-card-title class="text-body-2 font-weight-bold" style="color:#00d1d5;">
                    ※新型コロナウイルスの感染拡大状況により、内容・開催スケジュールの変更、または中止になる可能性があります。
                </v-card-title>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="black" text @click="dialog = false">
                        CLOSE
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    export default {

        computed: {
            binding() {
                const binding = {}

                if (this.$vuetify.breakpoint.xsOnly) binding.row = true

                return binding
            }
        },

        data() {
            return {
                dialog: false,
                notifications: false,
                sound: true,
                widgets: false,
                // コンテンツ情報
                //
                // thumbnail => サムネイル画像
                // title => タイトル
                // description => 詳細説明
                contents1: [{
                    title: '',
                    thumbnail: './Images/covid/covid_1.svg',
                    description: '入場時の検温で37.5℃以上の発熱がある方'
                }]
            }
        },
    }
</script>